module.exports = __webpack_public_path__ + "housingStatic/img/gjzz.2f9e180.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park_bg/gjzz.jpg
// module id = qcP/
// module chunks = 2